import * as React from 'react';
import Box from '@mui/material/Box';

export interface StatusToggleFrameProps {
  isActive?: boolean | null;
  children: React.ReactNode;
}

/**
 * A tinted pill around an Active/Inactive toggle so the control's state reads from across the
 * room: green while active, red while inactive. Tints go through `theme.alpha` on the palette CSS
 * variables, so they hold in both colour schemes without this component knowing which is on.
 */
export default function StatusToggleFrame({ isActive, children }: StatusToggleFrameProps) {
  const tone = isActive ? 'success' : 'error';
  return (
    <Box
      data-testid='status-toggle-frame'
      data-tone={tone}
      sx={(theme) => {
        // `vars` is the CSS-variables palette the app theme provides; a plain theme (tests that
        // render without the provider) falls back to the resolved colour.
        const main = (theme.vars ?? theme).palette[tone].main;
        return {
          display: 'inline-flex',
          alignItems: 'center',
          px: 1.5,
          py: 0.25,
          borderRadius: 999,
          border: 1,
          borderColor: theme.alpha(main, 0.5),
          bgcolor: theme.alpha(main, 0.12),
          transition: theme.transitions.create(['background-color', 'border-color'], {
            duration: theme.transitions.duration.shorter,
          }),
        };
      }}
    >
      {children}
    </Box>
  );
}
